const animationEventBuilder = require('./animation-event-factory');
const wowShop = require('angular').module('wowApp.shop');
const _ = require('lodash');

const animationEvents = [
    { directiveName: 'animationStart', eventName: 'AnimationStart' },
    { directiveName: 'animationIteration', eventName: 'AnimationIteration' },
    { directiveName: 'animationEnd', eventName: 'AnimationEnd' }
];

_.each(animationEvents, (animEvent) => {
    wowShop.directive(animEvent.directiveName, ['$parse', animationEventBuilder(animEvent)]);
});



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/animation-events/index.js
 **/